/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {WhmcsClient, WhmcsClientDetails} from '../../../../models/whmcs-client.model';
import {SMSMessage, SMSPredefined} from '../../../../models/sms.model';
import {BehaviorSubject} from 'rxjs';
import {SmsService} from '../../../../services/sms-service';

@Component({
	selector: 'app-dialog-predefined-sms',
	templateUrl: './dialog-predefined-sms.component.html',
	styleUrls: ['./dialog-predefined-sms.component.scss']
})
export class DialogPredefinedSmsComponent implements OnInit {

	loadingPredefinedSms$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	hasPredefinedSMSes$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	predefinedSMSes$: BehaviorSubject<SMSPredefined[]> = new BehaviorSubject<SMSPredefined[]>([]);

	constructor(
		public dialogRef: MatDialogRef<DialogPredefinedSmsComponent>,
		private smsService: SmsService
		// @Inject(MAT_DIALOG_DATA) public data: {
		// 	basic: WhmcsClient,
		// 	extra: WhmcsClientDetails
		// }
	) { }

	ngOnInit() {
		this.getPredefined();
	}

	getPredefined(){
		this.loadingPredefinedSms$.next(true);
		this.smsService.getPredefinedSms()
			.subscribe((pSMSes: SMSPredefined[]) => {
				this.predefinedSMSes$.next(pSMSes);
				this.hasPredefinedSMSes$.next(pSMSes.length > 0);
				this.loadingPredefinedSms$.next(false);
			});
	}

	onSelect(smsBody: string): void {
		this.dialogRef.close(smsBody);
	}

	onCloseClick(): void {
		this.dialogRef.close(null);
	}

}
